import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchPartsRequest from "./requests/searchPartsRequest";
import getPartBestCost from "./requests/getPartBestCost";
import deletePartRequest from "./requests/deletePartRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const partEndpoints: RequestDefinitionData[] = [
    searchPartsRequest,
    getPartBestCost,
    deletePartRequest,
];

export const partHeader = {
    title: 'Part',
    description: 'This is an object representing a Fishbowl part.',
    linkName: 'Part',
    link: 'https://www.fishbowlinventory.com/wiki/Part',
    endpoints: partEndpoints,
};

export const jsonObject: Json = {
    title: 'THE PART OBJECT',
    json: {}
};

export const partAttributes: Attribute[] = [];
